/* eslint-disable */

/**
 * Created by jiachenpan on 16/11/18.
 */

export function isvalidUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/**
 * 邮箱
 * @param {*}
 */
export function isEmail(s) {
  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile(s) {
  return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone(s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL(s) {
  return /^http[s]?:\/\/.*/.test(s)
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母*/
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/*验证pad还是pc*/
export const vaildatePc = function () {
  const userAgentInfo = navigator.userAgent;
  const Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"
  ];
  let flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email) {
  const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

/**
 * 判断身份证号码
 */
export function cardid(code) {
  let list = [];
  let result = true;
  let msg = '';
  var city = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北 ",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏 ",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外 "
  };
  if (!validatenull(code)) {
    if (code.length == 18) {
      if (!code || !/(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(code)) {
        msg = "证件号码格式错误";
      } else if (!city[code.substr(0, 2)]) {
        msg = "地址编码错误";
      } else {
        //18位身份证需要验证最后一位校验位
        code = code.split('');
        //∑(ai×Wi)(mod 11)
        //加权因子
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        //校验位
        var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2, 'x'];
        var sum = 0;
        var ai = 0;
        var wi = 0;
        for (var i = 0; i < 17; i++) {
          ai = code[i];
          wi = factor[i];
          sum += ai * wi;
        }
        if (parity[sum % 11] != code[17]) {
          msg = "证件号码校验位错误";
        } else {
          result = false;
        }

      }
    } else {
      msg = "证件号码长度不为18位";
    }

  } else {
    msg = "证件号码不能为空";
  }
  list.push(result);
  list.push(msg);
  return list;
}

/**
 * 判断手机号码是否正确
 */
export function isvalidatemobile(phone) {
  let list = [];
  let result = true;
  let msg = '';
  var isPhone = /^0\d{2,3}-?\d{7,8}$/;
  //增加134 减少|1349[0-9]{7}，增加181,增加145，增加17[678]
  if (!validatenull(phone)) {
    if (phone.length == 11) {
      if (isPhone.test(phone)) {
        msg = '手机号码格式不正确';
      } else {
        result = false;
      }
    } else {
      msg = '手机号码长度不为11位';
    }
  } else {
    msg = '手机号码不能为空';
  }
  list.push(result);
  list.push(msg);
  return list;
}

/**
 * 判断姓名是否正确
 */
export function validatename(name) {
  var regName = /^[\u4e00-\u9fa5]{2,4}$/;
  if (!regName.test(name)) return false;
  return true;
}

/**
 * 判断是否为整数
 */
export function validatenum(num, type) {
  let regName = /[^\d.]/g;
  if (type == 1) {
    if (!regName.test(num)) return false;
  } else if (type == 2) {
    regName = /[^\d]/g;
    if (!regName.test(num)) return false;
  }
  return true;
}

/**
 * 判断是否为小数
 */
export function validatenumord(num, type) {
  let regName = /[^\d.]/g;
  if (type == 1) {
    if (!regName.test(num)) return false;
  } else if (type == 2) {
    regName = /[^\d.]/g;
    if (!regName.test(num)) return false;
  }
  return true;
}

/**
 * 判断是否为空
 */
export function validatenull(val) {
  if (typeof val == 'boolean') {
    return false;
  }
  if (typeof val == 'number') {
    return false;
  }
  if (val instanceof Array) {
    if (val.length == 0) return true;
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true;
  } else {
    if (val == 'null' || val == null || val == 'undefined' || val == undefined || val == '') return true;
    return false;
  }
  return false;
}

/**
 * 自定义验证
 * 验证字符串
 */
export function vString(name, min = 1, max = 200) {
  return function (rule, val, cb) {
    // 空值
    if (val === null || val === undefined || val === '') {
      cb(new Error(`${name}不能为空`))
    }
    // 过短
    else if (isNaN(min) === false && val.length < min) {
      cb(new Error(`${name}长度不能小于${min}`))
    }
    // 过长
    else if (isNaN(max) === false && val.length > max) {
      cb(new Error(`${name}长度不能大于${max}`))
    } else {
      cb();
    }
  }
}

export function vDateRange(name) {
  return function (rule, val, cb) {
    if (!val[0] || !val[1]) {
      cb(new Error(`请选择${name}`))
    }
    cb();
  }
}

export function vInt(name = '', min, max) {
  return function (rule, val, cb) {
    if (isNaN(val) || !/^\d+$/.test(val)) {
      cb(new Error(`${name}必须是数字`))
    }
    // 过短
    if (isNaN(min) === false && (val < min || val > max)) {
      cb(new Error(`${name}大小需要在${min}和${max}之间`))
    }
    cb();
  }
}

export function vMoney() {
  return function (rule, val, cb) {
    if (isNaN(val) || !/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(val)) {
      cb(new Error(`${name}请输入最多2位小数的金额`))
    } else if ((val + "").length > 13) {
      cb(new Error(`金额过大`))
    }
    cb();
  }
}

export function vMoney2(name) {
  return function (rule, val, cb) {
    if (isNaN(val) || !/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(val)) {
      cb(new Error(`${name}请输入最多2位小数的金额`))
    } else if ((val + "").length > 13) {
      cb(new Error(`${name}金额过大`))
    } else {
      cb();
    }
  }
}

export function vLongitude() {
  return function (rule, val, cb) {
    if (!/^[\-\+]?(0(\.\d{1,10})?|([1-9](\d)?)(\.\d{1,10})?|1[0-7]\d{1}(\.\d{1,10})?|180\.0{1,10})$/.test(val)) {
      cb(new Error('请输入正确的经度'))
    } else {
      cb()
    }
  }
}

export function vLatitude() {
  return function (rule, val, cb) {
    if (!/^[\-\+]?((0|([1-8]\d?))(\.\d{1,10})?|90(\.0{1,10})?)$/.test(val)) {
      cb(new Error('请输入正确的纬度'))
    } else {
      cb()
    }
  }
}

//判断输入数字大小区间
export function numberSize(min, max) {
  return (rule, value, callback) => {
    if (typeof min == 'undefined' && min !== '-' && value.length < min) {
      callback(new Error(`请输入大于等于${minLength}数字!`));
    } else if (typeof min == 'undefined' && max !== '+' && value.length > max) {
      callback(new Error(`请输入小于等于${maxLength}数字!`));
    } else {
      callback();
    }
  };
}

//cron表达式校验
export function cronValidator(rule, value, callback){
  if(cronValidate(value,rule.required)){
    callback();
  }else {
    callback(new Error(rule.message));
  }
}


export function cronValidate(value,required) {
  var results = true;
  if (value == null || value.length === 0) {
    return !required;
  }
  var expressionArray = value.split(' ');
  var len = expressionArray.length;

  if ((len !== 6) && (len !== 7)) {
    return false;
  }

  // check only one question mark
  var match = value.match(/\?/g);
  if (match != null && match.length > 1) {
    return false;
  }

  // check only one question mark
  var dayOfTheMonthWildcard = "";

  // if appropriate length test parts
  // [0] Seconds 0-59 , - * /
  if (isNotWildCard(expressionArray[0], /[\*]/gi)) {
    if (!segmentValidator("([0-9\\\\,-\\/])", expressionArray[0], [0, 59], "seconds")) {
      return false;
    }
  }

  // [1] Minutes 0-59 , - * /
  if (isNotWildCard(expressionArray[1], /[\*]/gi)) {
    if (!segmentValidator("([0-9\\\\,-\\/])", expressionArray[1], [0, 59], "minutes")) {
      return false;
    }
  }

  // [2] Hours 0-23 , - * /
  if (isNotWildCard(expressionArray[2], /[\*]/gi)) {
    if (!segmentValidator("([0-9\\\\,-\\/])", expressionArray[2], [0, 23], "hours")) {
      return false;
    }
  }

  // [3] Day of month 1-31 , - * ? / L W C
  if (isNotWildCard(expressionArray[3], /[\*\?]/gi)) {
    if (!segmentValidator("([0-9LWC\\\\,-\\/])", expressionArray[3], [1, 31], "days of the month")) {
      return false;
    }
  } else {
    dayOfTheMonthWildcard = expressionArray[3];
  }

  // [4] Month 1-12 or JAN-DEC , - * /
  if (isNotWildCard(expressionArray[4], /[\*]/gi)) {
    expressionArray[4] = convertMonthsToInteger(expressionArray[4]);
    if (!segmentValidator("([0-9\\\\,-\\/])", expressionArray[4], [1, 12], "months")) {
      return false;
    }
  }

  // [5] Day of week 1-7 or SUN-SAT , - * ? / L C #
  if (isNotWildCard(expressionArray[5], /[\*\?]/gi)) {
    expressionArray[5] = convertDaysToInteger(expressionArray[5]);
    if (!segmentValidator("([0-9LC#\\\\,-\\/])", expressionArray[5], [1, 7], "days of the week")) {
      return false;
    }
  } else {
    if (dayOfTheMonthWildcard == String(expressionArray[5])) {
      return false;
    }
  }

  // [6] Year empty or 1970-2099 , - * /
  if (len === 7) {
    if (isNotWildCard(expressionArray[6], /[\*]/gi)) {
      if (!segmentValidator("([0-9\\\\,-\\/])", expressionArray[6], [1970, 2099], "years")) {
        return false;
      }
    }
  }
  return true;
}
function isNotWildCard(value, expression) {
  var match = value.match(expression);
  return (match === null || match.length === 0);
}
function convertDaysToInteger(value) {
  var v = value;
  v = v.replace(/SUN/gi, "1");
  v = v.replace(/MON/gi, "2");
  v = v.replace(/TUE/gi, "3");
  v = v.replace(/WED/gi, "4");
  v = v.replace(/THU/gi, "5");
  v = v.replace(/FRI/gi, "6");
  v = v.replace(/SAT/gi, "7");
  return v;
}
function convertMonthsToInteger(value) {
  var v = value;
  v = v.replace(/JAN/gi, "1");
  v = v.replace(/FEB/gi, "2");
  v = v.replace(/MAR/gi, "3");
  v = v.replace(/APR/gi, "4");
  v = v.replace(/MAY/gi, "5");
  v = v.replace(/JUN/gi, "6");
  v = v.replace(/JUL/gi, "7");
  v = v.replace(/AUG/gi, "8");
  v = v.replace(/SEP/gi, "9");
  v = v.replace(/OCT/gi, "10");
  v = v.replace(/NOV/gi, "11");
  v = v.replace(/DEC/gi, "12");
  return v;
}
function segmentValidator(expression, value, range, segmentName) {
  var v = value;
  var numbers = [];

  // first, check for any improper segments  
  var reg = new RegExp(expression, "gi");
  if (!reg.test(v)) {
    return false;
  }

  // check duplicate types  
  // check only one L  
  var dupMatch = value.match(/L/gi);
  if (dupMatch != null && dupMatch.length > 1) {
    return false;
  }

  // look through the segments  
  // break up segments on ','  
  // check for special cases L,W,C,/,#,-  
  var split = v.split(",");
  var i = -1;
  var l = split.length;
  var match;

  while (++i < l) {
    // set vars  
    var checkSegment = split[i];
    var n;
    var pattern = /(\w*)/;
    match = pattern.exec(checkSegment);

    // if just number  
    pattern = /(\w*)\-?\d+(\w*)/;
    match = pattern.exec(checkSegment);

    if (match
      && match[0] === checkSegment
      && checkSegment.indexOf("L") === -1
      && checkSegment.indexOf("l") === -1
      && checkSegment.indexOf("C") === -1
      && checkSegment.indexOf("c") === -1
      && checkSegment.indexOf("W") === -1
      && checkSegment.indexOf("w") === -1
      && checkSegment.indexOf("/") === -1
      && (checkSegment.indexOf("-") === -1 || checkSegment
        .indexOf("-") === 0) && checkSegment.indexOf("#") === -1) {
      n = match[0];

      if (n && !(isNaN(n)))
        numbers.push(n);
      else if (match[0] === "0")
        numbers.push(n);
      continue;
    }
    // includes L, C, or w  
    pattern = /(\w*)L|C|W(\w*)/i;
    match = pattern.exec(checkSegment);

    if (match
      && match[0] !== ""
      && (checkSegment.indexOf("L") > -1
        || checkSegment.indexOf("l") > -1
        || checkSegment.indexOf("C") > -1
        || checkSegment.indexOf("c") > -1
        || checkSegment.indexOf("W") > -1 || checkSegment
          .indexOf("w") > -1)) {

      // check just l or L  
      if (checkSegment === "L" || checkSegment === "l")
        continue;
      pattern = /(\w*)\d+(l|c|w)?(\w*)/i;
      match = pattern.exec(checkSegment);

      // if something before or after  
      if (!match || match[0] !== checkSegment) {
        continue;
      }

      // get the number  
      var numCheck = match[0];
      numCheck = numCheck.replace(/(l|c|w)/ig, "");

      n = Number(numCheck);

      if (n && !(isNaN(n)))
        numbers.push(n);
      else if (match[0] === "0")
        numbers.push(n);
      continue;
    }

    var numberSplit;

    // includes /  
    if (checkSegment.indexOf("/") > -1) {
      // take first #  
      numberSplit = checkSegment.split("/");

      if (numberSplit.length !== 2) {
        continue;
      } else {
        n = numberSplit[0];

        if (n && !(isNaN(n)))
          numbers.push(n);
        else if (numberSplit[0] === "0")
          numbers.push(n);
        continue;
      }
    }

    // includes #  
    if (checkSegment.indexOf("#") > -1) {
      // take first #  
      numberSplit = checkSegment.split("#");

      if (numberSplit.length !== 2) {
        continue;
      } else {
        n = numberSplit[0];

        if (n && !(isNaN(n)))
          numbers.push(n);
        else if (numberSplit[0] === "0")
          numbers.push(n);
        continue;
      }
    }

    // includes -  
    if (checkSegment.indexOf("-") > 0) {
      // take both #  
      numberSplit = checkSegment.split("-");

      if (numberSplit.length !== 2) {
        
      } else if (Number(numberSplit[0]) > Number(numberSplit[1])) {
        
      } else {
        n = numberSplit[0];

        if (n && !(isNaN(n)))
          numbers.push(n);
        else if (numberSplit[0] === "0")
          numbers.push(n);
        n = numberSplit[1];

        if (n && !(isNaN(n)))
          numbers.push(n);
        else if (numberSplit[1] === "0")
          numbers.push(n);
        
      }
    }

  }
  // lastly, check that all the found numbers are in range  
  i = -1;
  l = numbers.length;

  if (l === 0)
    return false;

  while (++i < l) {
    // alert(numbers[i]);  
    if (numbers[i] < range[0] || numbers[i] > range[1]) {
      return false;
    }
  }
  return true;
}
